import type { SVGProps } from "react";
export interface MustacheIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MustacheIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MustacheIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.062 5.98c1.115-.25 2.249-.053 3.418.505l.63.288c.61.268 1.16.467 1.67.555.643.112 1.146.035 1.597-.265a1.125 1.125 0 0 1 1.748.938c0 3.732-1.331 6.979-3.548 8.752-1.122.897-2.47 1.41-3.936 1.371-1.221-.032-2.453-.446-3.643-1.235-1.19.788-2.422 1.203-3.642 1.235-1.466.039-2.814-.474-3.936-1.37C2.203 14.98.872 11.733.872 8a1.126 1.126 0 0 1 1.748-.938c.45.3.954.377 1.598.265.68-.117 1.433-.43 2.298-.843l.437-.192c1.016-.408 2.006-.53 2.982-.312.76.17 1.439.535 2.063 1.02.623-.485 1.303-.85 2.064-1.02m2.452 2.535c-.837-.399-1.453-.452-1.96-.338-.522.117-1.083.445-1.74 1.098l-.018.02a1.12 1.12 0 0 1-1.2.253q-.01-.004-.02-.006a1.1 1.1 0 0 1-.375-.246l-.024-.028c-.654-.649-1.214-.975-1.734-1.091-.507-.114-1.122-.06-1.959.338-.876.417-1.873.855-2.884 1.03-.449.077-.912.1-1.378.051.31 2.484 1.33 4.38 2.604 5.4.754.602 1.593.903 2.471.88.873-.023 1.88-.371 2.965-1.23q.027-.02.054-.039.051-.039.104-.07.03-.02.062-.037.025-.01.05-.02a1 1 0 0 1 .145-.057c.032-.01.065-.014.098-.02.039-.009.077-.02.117-.023l.016-.001h.179l.015.001q.071.01.143.026c.022.005.045.007.066.014q.087.026.17.067l.03.013a1 1 0 0 1 .188.12l.002.002.032.025c1.085.859 2.094 1.206 2.968 1.229.877.023 1.717-.278 2.47-.88 1.274-1.02 2.293-2.917 2.604-5.4a5 5 0 0 1-1.378-.051c-1.011-.175-2.007-.613-2.883-1.03"
      />
    </svg>
  );
}
